<div class="container-fluid">
    <h3>Iniciativa Masiva</h3>
    <div class="row">
        <div class="col-md-8">
            <h4>Carga un documento para activar o inactivar un listado de clientes en una iniciativa.</h4>
        </div>
        <div class="col-md-4">
            <!-- Funcionalidad removida: El botón de descargar plantilla fue eliminado debido a la remoción de la librería xlsx -->
            <!-- <button type="button" class="btn tabgestion" (click)="downloadTemplate()">Descargar Plantilla <img
                    height="20" style="margin-left: 5px;" src="../../assets/images/general/downloadfile.png" ></button> -->
        </div>
    </div>
    <form [formGroup]="iniciativaForm">
        <div class="inciativaform">
            <div class="row">
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="exampleFormControlSelect1">Iniciativa</label>
                        <select class="form-control" formControlName="iniciativa" name="plazo">
                            <option value="1002" *ngxPermissionsOnly="['retencionReactiva']">Retención Reactiva</option>
                            <option value="1001" *ngxPermissionsOnly="['retencionProactiva']">Retención Proactiva</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-8">
                    <p>Carga de documento</p>
                    <!-- Funcionalidad removida: La carga de documentos Excel fue eliminada debido a la remoción de la librería xlsx -->
                    <!-- <input type="file" class="file-input" accept=".xlsx" (change)="onFileSelected($event)" #fileUpload>
                    <div class="input-group" (click)="fileUpload.click()">
                        <input type="text" formControlName="fileselected" class="form-control"
                            style="border-style: solid none solid solid !important;" #codigopatrono readonly>
                        <div class="input-group-btn">
                            <button class="btn" >
                                <span><img src="../../assets/icons/lupa.png" height="18px"></span>
                            </button>
                        </div>
                    </div> -->
                    <p class="alert alert-warning">Funcionalidad de carga de documentos temporalmente deshabilitada</p>
                </div>
                <div class="col-md-12">
                    <p>Tipo de proceso</p>
                </div>
                <div class="col-md-4">
                    <div class="divcheck">
                        <div class="row">
                            <div class="col-md-8">
                                <h4>Activar cliente</h4>
                            </div>
                            <div class="col-md-4">
                                <label class="containercheck">
                                    <input *ngIf="iniciativaForm.get('tipoProceso').value=='1'" type="checkbox" (change)="changeProcessType(1)" id="1" checked>
                                    <input *ngIf="iniciativaForm.get('tipoProceso').value!='1'" type="checkbox" (change)="changeProcessType(1)" id="1">
                                    <span class="checkmark"></span>
                                    <span class="checkmark"></span>
                                  </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="divcheck">
                        <div class="row">
                            <div class="col-md-8">
                                <h4>Inactivar cliente</h4>
                            </div>
                            <div class="col-md-4">
                                <label class="containercheck">
                                    <input *ngIf="iniciativaForm.get('tipoProceso').value=='2'" type="checkbox" (change)="changeProcessType(2)" id="2" checked>
                                    <input *ngIf="iniciativaForm.get('tipoProceso').value!='2'" type="checkbox"(change)="changeProcessType(2)" id="2" >
                                    <span class="checkmark"></span>
                                  </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <button class="btn round-button" (click)="enviarIniciativa()">Enviar</button>
    </form>
</div>